import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from 'axios';

const baseUrl = process.env.REACT_APP_BASE_URL;

//action


export const clothIssueEntry = createAsyncThunk('clothIssueEntry', async (postData) => {
    try {
        const response = await axios.post(`${baseUrl}?apicall=InsertClothIssue`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const updateClothIssue = createAsyncThunk('updateClothIssue', async (postData) => {
    try {
        const response = await axios.post(`${baseUrl}?apicall=updateClothIssue`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const InsertCuttingEntry = createAsyncThunk('InsertCuttingEntry', async (postData) => {
    try {
        const response = await axios.post(`${baseUrl}?apicall=insertInhouseCutting`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const UpdateCuttingEntry = createAsyncThunk('UpdateCuttingEntry', async (postData) => {
    try {
        const response = await axios.post(`${baseUrl}?apicall=updateCuttingEntry`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const insertClothIssueLump = createAsyncThunk('insertClothIssueLump', async (postData) => {
    try {
        const response = await axios.post(`${baseUrl}?apicall=ClothIssueLumpUpdates`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchChallanNo = createAsyncThunk('fetchChallanNo', async () => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getChallanNo`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchClothStkBale = createAsyncThunk('fetchClothStkBale', async () => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getClothStkBalelist`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchClothIssueData = createAsyncThunk('fetchClothIssueData', async (id) => {
    try {
        const endpoint = id ? `getClothIssuelist&cIssueId=${id}` : 'getClothIssuelist';
        const response = await axios.get(`${baseUrl}?apicall=${endpoint}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchClothIssueInfo = createAsyncThunk('fetchClothIssueInfo', async (id) => {
    try {
        const endpoint = id ? `getClothIssueInfolist&cIssueId=${id}` : 'getClothIssueInfolist';
        const response = await axios.get(`${baseUrl}?apicall=${endpoint}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});


export const fetchLumpBarcode = createAsyncThunk('fetchLumpBarcode', async () => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getLumpBarcode`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchChanllanId = createAsyncThunk('fetchChanllanId', async () => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getChallanIdClothIssue`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const deleteClothIssue = createAsyncThunk('deleteClothIssue', async (id) => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=deleteClothIssue&cIssueId=${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});




const clothIssueSlice = createSlice({
    name: 'ClothIssueData',
    initialState: {
        isLoading: false,
        challanNo: null,
        baleList: null,
        clothIssue: null,
        clothIsInfo: null,
        deleteClIssue: null,
        lumpbarcd: null,
        chanllanId: null,
        isError: false
    },
    extraReducers: (builder) => {
        builder.addCase(fetchChallanNo.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchChallanNo.fulfilled, (state, action) => {
            state.isLoading = false;
            state.challanNo = action.payload;
        });
        builder.addCase(fetchChallanNo.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(fetchClothStkBale.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchClothStkBale.fulfilled, (state, action) => {
            state.isLoading = false;
            state.baleList = action.payload;
        });
        builder.addCase(fetchClothStkBale.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(fetchClothIssueData.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchClothIssueData.fulfilled, (state, action) => {
            state.isLoading = false;
            state.clothIssue = action.payload;
        });
        builder.addCase(fetchClothIssueData.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(fetchClothIssueInfo.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchClothIssueInfo.fulfilled, (state, action) => {
            state.isLoading = false;
            state.clothIsInfo = action.payload;
        });
        builder.addCase(fetchClothIssueInfo.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(deleteClothIssue.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(deleteClothIssue.fulfilled, (state, action) => {
            state.isLoading = false;
            state.deleteClIssue = action.payload;
        });
        builder.addCase(deleteClothIssue.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });


        builder.addCase(fetchLumpBarcode.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchLumpBarcode.fulfilled, (state, action) => {
            state.isLoading = false;
            state.lumpbarcd = action.payload;
        });
        builder.addCase(fetchLumpBarcode.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });


        builder.addCase(fetchChanllanId.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchChanllanId.fulfilled, (state, action) => {
            state.isLoading = false;
            state.chanllanId = action.payload;
        });
        builder.addCase(fetchChanllanId.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });
    }
});

export default clothIssueSlice.reducer;
